// src/graphql/mutations/setFeatures.js
import { gql } from '@apollo/client';

export const SET_FEATURES = gql`
  mutation setFeatures($system_id: String!, $features: FeaturesInput!) {
    setFeatures(system_id: $system_id, features: $features) {
      result
    }
  }
`;
